/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerBlock } from '../fn/admin/admin-controller-block';
import { AdminControllerBlock$Params } from '../fn/admin/admin-controller-block';
import { adminControllerCheckEmail } from '../fn/admin/admin-controller-check-email';
import { AdminControllerCheckEmail$Params } from '../fn/admin/admin-controller-check-email';
import { adminControllerCreate } from '../fn/admin/admin-controller-create';
import { AdminControllerCreate$Params } from '../fn/admin/admin-controller-create';
import { adminControllerDeleteAdmin } from '../fn/admin/admin-controller-delete-admin';
import { AdminControllerDeleteAdmin$Params } from '../fn/admin/admin-controller-delete-admin';
import { adminControllerGetAdmin } from '../fn/admin/admin-controller-get-admin';
import { AdminControllerGetAdmin$Params } from '../fn/admin/admin-controller-get-admin';
import { adminControllerLogout } from '../fn/admin/admin-controller-logout';
import { AdminControllerLogout$Params } from '../fn/admin/admin-controller-logout';
import { adminControllerMe } from '../fn/admin/admin-controller-me';
import { AdminControllerMe$Params } from '../fn/admin/admin-controller-me';
import { adminControllerRefresh } from '../fn/admin/admin-controller-refresh';
import { AdminControllerRefresh$Params } from '../fn/admin/admin-controller-refresh';
import { adminControllerResetPassword } from '../fn/admin/admin-controller-reset-password';
import { AdminControllerResetPassword$Params } from '../fn/admin/admin-controller-reset-password';
import { adminControllerSearchOffset } from '../fn/admin/admin-controller-search-offset';
import { AdminControllerSearchOffset$Params } from '../fn/admin/admin-controller-search-offset';
import { adminControllerSignIn } from '../fn/admin/admin-controller-sign-in';
import { AdminControllerSignIn$Params } from '../fn/admin/admin-controller-sign-in';
import { adminControllerUnBlock } from '../fn/admin/admin-controller-un-block';
import { AdminControllerUnBlock$Params } from '../fn/admin/admin-controller-un-block';
import { adminControllerUpdate } from '../fn/admin/admin-controller-update';
import { AdminControllerUpdate$Params } from '../fn/admin/admin-controller-update';
import { AdminDto } from '../models/admin-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerMe()` */
  static readonly AdminControllerMePath = '/api/admin/me';

  /**
   * 내 정보.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerMe$Response(params?: AdminControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerMe(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 정보.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerMe(params?: AdminControllerMe$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerCheckEmail()` */
  static readonly AdminControllerCheckEmailPath = '/api/admin/check-email';

  /**
   * 이메일 중복 확인.
   *
   * 이메일 중복을 확인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCheckEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerCheckEmail$Response(params: AdminControllerCheckEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerCheckEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * 이메일 중복 확인.
   *
   * 이메일 중복을 확인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCheckEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerCheckEmail(params: AdminControllerCheckEmail$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerCheckEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerSearchOffset()` */
  static readonly AdminControllerSearchOffsetPath = '/api/admin/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   * 관리자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset$Response(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   * 관리자를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminControllerGetAdmin()` */
  static readonly AdminControllerGetAdminPath = '/api/admin/{id}';

  /**
   * 관리자 조회.
   *
   * 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerGetAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetAdmin$Response(params: AdminControllerGetAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerGetAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 조회.
   *
   * 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerGetAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerGetAdmin(params: AdminControllerGetAdmin$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerGetAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDeleteAdmin()` */
  static readonly AdminControllerDeleteAdminPath = '/api/admin/{id}';

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDeleteAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteAdmin$Response(params: AdminControllerDeleteAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerDeleteAdmin(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDeleteAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDeleteAdmin(params: AdminControllerDeleteAdmin$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerDeleteAdmin$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerUpdate()` */
  static readonly AdminControllerUpdatePath = '/api/admin/{id}';

  /**
   * 관리자 정보 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate$Response(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 정보 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerCreate()` */
  static readonly AdminControllerCreatePath = '/api/admin';

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate$Response(params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate(params: AdminControllerCreate$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerSignIn()` */
  static readonly AdminControllerSignInPath = '/api/admin/signin';

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignIn()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn$Response(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    return adminControllerSignIn(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignIn$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    return this.adminControllerSignIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerRefresh()` */
  static readonly AdminControllerRefreshPath = '/api/admin/refresh';

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerRefresh()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh$Response(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
    return adminControllerRefresh(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerRefresh$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
}> {
    return this.adminControllerRefresh$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
}>): {
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerLogout()` */
  static readonly AdminControllerLogoutPath = '/api/admin/signout';

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout$Response(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerBlock()` */
  static readonly AdminControllerBlockPath = '/api/admin/{id}/block';

  /**
   * 관리자 차단.
   *
   * 관리자를 차단합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlock$Response(params: AdminControllerBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerBlock(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 차단.
   *
   * 관리자를 차단합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerBlock(params: AdminControllerBlock$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerUnBlock()` */
  static readonly AdminControllerUnBlockPath = '/api/admin/{id}/unBlock';

  /**
   * 관리자 차단 해제.
   *
   * 관리자 차단을 해제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUnBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerUnBlock$Response(params: AdminControllerUnBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerUnBlock(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 차단 해제.
   *
   * 관리자 차단을 해제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUnBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerUnBlock(params: AdminControllerUnBlock$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerUnBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminControllerResetPassword()` */
  static readonly AdminControllerResetPasswordPath = '/api/admin/{id}/reset-password';

  /**
   * 비밀번호 재설정.
   *
   * 비밀번호를 재설정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerResetPassword()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerResetPassword$Response(params: AdminControllerResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return adminControllerResetPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * 비밀번호 재설정.
   *
   * 비밀번호를 재설정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerResetPassword$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerResetPassword(params: AdminControllerResetPassword$Params, context?: HttpContext): Observable<void> {
    return this.adminControllerResetPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
